import { createSelector } from "@reduxjs/toolkit";

import { filterSupportedMetricDescriptors } from "Api/metricsExplorer/filterSupportedMetricDescriptors";
import { RootState } from "Store/configureStore";

import { initialMetricTimelineState, initialMetricsListState } from "./helpers";
import {
  MetricTimelineKey,
  MetricTimelineState,
  MetricsListScopeKey,
  MetricsListState
} from "./types";

const selectSelf = (state: RootState) => state.metricsExplorer;

export const selectMetricsListState = createSelector(
  selectSelf,
  (_: RootState, scopeKey: MetricsListScopeKey) => scopeKey,
  (state, scopeKey): MetricsListState =>
    state.lists[scopeKey] ?? initialMetricsListState
);

export const selectSupportedMetricsListState = createSelector(
  selectMetricsListState,
  listState => {
    const data = filterSupportedMetricDescriptors(listState.data);
    return data === listState.data ? listState : { ...listState, data };
  }
);

export const selectMetricTimelineState = createSelector(
  selectSelf,
  (_: RootState, timelineKey: MetricTimelineKey) => timelineKey,
  (state, timelineKey): MetricTimelineState =>
    state.timelines[timelineKey] ?? initialMetricTimelineState
);
